import { LoadingSpinner, Size } from "@solace-health/ui";

import ULThemeCard from "@/components/ULThemeCard";
import ULThemePageLayout from "@/components/ULThemePageLayout";

import { Footer } from "./components/Footer";
import { Header } from "./components/Header";

export const Loading = () => {
  return (
    <ULThemePageLayout className="theme-universal">
      <ULThemeCard className="w-full max-w-[400px] gap-0">
        <Header />
        <div className="flex w-full size-52 items-center justify-center">
          <LoadingSpinner size={Size.XL} />
        </div>
        <Footer />
      </ULThemeCard>
    </ULThemePageLayout>
  );
};
